<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { shouldBeUrl } from 'shared/helpers/Validators';
import { useAlert } from 'dashboard/composables';
import router from '../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      provider: 'personal_web',
      phoneNumber: '',
      botToken: '',
      gatewayUrl:
        window.chatwootConfig?.maxPersonalGatewayUrl ||
        'http://max_personal_gateway:3300',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations() {
    return {
      inboxName: { required },
      phoneNumber: {
        required: value =>
          this.provider === 'bot' || required.$validator(value),
      },
      botToken: {
        required: value =>
          this.provider === 'personal_web' || required.$validator(value),
      },
      gatewayUrl: {
        required: value =>
          this.provider === 'bot' || required.$validator(value),
        shouldBeUrl: value => this.provider === 'bot' || shouldBeUrl(value),
      },
    };
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const maxChannel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName?.trim(),
          channel: {
            type: 'max',
            provider: this.provider,
            phone_number:
              this.provider === 'personal_web' ? this.phoneNumber?.trim() : '',
            provider_config: {
              ...(this.provider === 'personal_web'
                ? { gateway_url: this.gatewayUrl?.trim() }
                : { bot_token: this.botToken?.trim() }),
            },
          },
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: maxChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.MAX.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
    <p class="mb-6 text-sm leading-relaxed text-n-slate-11">
      {{ $t('INBOX_MGMT.ADD.MAX.DESCRIPTION') }}
    </p>

    <div class="flex-shrink-0 flex-grow-0">
      <label>
        {{ $t('INBOX_MGMT.ADD.MAX.PROVIDER.LABEL') }}
        <select v-model="provider">
          <option value="personal_web">
            {{ $t('INBOX_MGMT.ADD.MAX.PROVIDER.PERSONAL') }}
          </option>
          <option value="bot">
            {{ $t('INBOX_MGMT.ADD.MAX.PROVIDER.BOT') }}
          </option>
        </select>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
      </label>
    </div>

    <div v-if="provider === 'personal_web'" class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.phoneNumber.$error }">
        {{ $t('INBOX_MGMT.ADD.MAX.PHONE_NUMBER.LABEL') }}
        <input
          v-model="phoneNumber"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.MAX.PHONE_NUMBER.PLACEHOLDER')"
          @blur="v$.phoneNumber.$touch"
        />
      </label>
    </div>

    <div v-if="provider === 'personal_web'" class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.gatewayUrl.$error }">
        {{ $t('INBOX_MGMT.ADD.MAX.GATEWAY_URL.LABEL') }}
        <input
          v-model="gatewayUrl"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.MAX.GATEWAY_URL.PLACEHOLDER')"
          @blur="v$.gatewayUrl.$touch"
        />
      </label>
    </div>

    <div v-if="provider === 'bot'" class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.botToken.$error }">
        {{ $t('INBOX_MGMT.ADD.MAX.BOT_TOKEN.LABEL') }}
        <input
          v-model="botToken"
          type="password"
          :placeholder="$t('INBOX_MGMT.ADD.MAX.BOT_TOKEN.PLACEHOLDER')"
          @blur="v$.botToken.$touch"
        />
      </label>
    </div>

    <div class="w-full mt-4">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.MAX.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>
